export function formatBytes(a,b=2){if(0===a)return"0 Bytes";const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));return parseFloat((a/Math.pow(1024,d)).toFixed(c))+" "+["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][d]}
export function normalizeValue(value) {
    if(value) {
        value = value.toLowerCase();
        value = value.replace(/[\W_]+/g, "");
    }
    return value;
}
export function sliceIntoChunks(arr, chunkSize) {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
    }
    return res;
}
export function toTitleCase(value) {
    if(!value || value.length < 1) {
        return value;
    }

    return value.substring(0,1).toUpperCase() + value.substring(1);
}